export default {
    data() {
        return {
            audioData: {
                play: false,
                allTime: 0,
                currentTime: 0
            },
            showPlayer: false,
        }
    },
    methods: {
        loadAudio(event) {
            this.audioData = {
                play: false,
                allTime: Math.round(event.target.duration),
                currentTime: event.target.currentTime
            };
            this.showPlayer = true;
        },
        returnSecondToMinute(allSecond) {
            let minute = Math.floor(allSecond / 60);
            let second = allSecond % 60;
            return `${this.fillZero(2, String(minute))}:${this.fillZero(2, String(second))}`
        },
        fillZero(width, str){
            return str.length >= width ? str:new Array(width-str.length+1).join('0')+str;//남는 길이만큼 0으로 채움
        },
        runPlay() {
            this.audioData.play = !this.audioData.play;
            if(this.audioData.play) {
                this.$refs.player.play();
            }else{
                this.$refs.player.pause();
            }
        },
        durationChange(event) {
            this.audioData.currentTime = Math.round(event.target.currentTime);
        },
        prevSecond(second=10) {
            this.$refs.player.currentTime -= second
        },
        nextSecond(second=10) {
            this.$refs.player.currentTime += second
        },
        returnPercent() {
            return Math.round((this.audioData.currentTime / this.audioData.allTime) * 100)
        },
    },
}
